export const CONTACT_NUMBER = "1-877-398-3496";
